import { render, staticRenderFns } from "./MMP_UserProfile.vue?vue&type=template&id=2660e2c7&scoped=true&"
import script from "./MMP_UserProfile.vue?vue&type=script&lang=js&"
export * from "./MMP_UserProfile.vue?vue&type=script&lang=js&"
import style0 from "./MMP_UserProfile.vue?vue&type=style&index=0&id=2660e2c7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2660e2c7",
  null
  
)

export default component.exports